import * as React from "react"
import { cn } from "@/lib/utils"

const sizeMap = {
  sm: "lg:h-10 h-8",
  md: "xl:h-[50px] md:h-[44px] h-[40px]",
  lg: "lg:h-[54px] md:h-[48px] h-[44px]",
}

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  error?: boolean
  helperText?: string
  size?: "sm" | "md" | "lg"
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, helperText, size = "md", startIcon, endIcon, ...props }, ref) => {
    return (
      <div className="space-y-1 w-full">
        <div className="relative flex items-center">
          {startIcon && (
            <span className="absolute left-3 flex items-center text-muted-foreground pointer-events-none">
              {startIcon}
            </span>
          )}
          <input
            type={type}
            className={cn(
              "flex rounded-[12px] w-full border border-border hover:border-border-light bg-background px-[14px] text-base ring-offset-background file:border-0 file:bg-transparent file:text-base file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
              sizeMap[size],
              startIcon && "pl-9",
              endIcon && "pr-9",
              error && "border-destructive focus-visible:ring-destructive",
              className
            )}
            ref={ref}
            {...props}
          />
          {endIcon && (
            <span className="absolute right-3 flex items-center text-muted-foreground pointer-events-none">
              {endIcon}
            </span>
          )}
        </div>
        {helperText && (
          <span className={cn("text-xs", error ? "text-destructive" : "text-muted-foreground")}>
            {helperText}
          </span>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
